import * as Yup from 'yup'
import { Form,  Col, Row } from 'react-bootstrap'
import { Options } from '../SelectOptions';
import { CustomFormSelect } from '../../../../StyledComponents';

export const Schema = Yup.object().shape({
    salutation: Yup.string().required("Angabe ist erforderlich"),
});

export const SalutationSubForm = ({ form: { values, handleBlur, handleChange, touched, errors }, ...props }) => {
    const { colors } = props;
    return (
        <>
            <Row className="mb-3">
            <Form.Group as={Col} controlId="formSalutation">
                    <Form.Label>Anrede*</Form.Label>
                    <CustomFormSelect
                        colors={colors}
                        name="salutation"
                        value={values.salutation}
                        isValid={touched.salutation && !errors.salutation}
                        isInvalid={touched.salutation && errors.salutation}
                        onChange={handleChange}
                        onBlur={handleBlur}
                    >
                        <option value="">Bitte auswählen...</option>
                        {Options.Salutation.map((item, index) => <option key={index} value={item.value}>{item.text}</option>)}
                    </CustomFormSelect>
                    <Form.Control.Feedback type="invalid">
                        {errors.salutation}
                    </Form.Control.Feedback>
                </Form.Group>
                <Form.Group as={Col}>
                </Form.Group>
            </Row>
        </>
    );
};